var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Popper',{class:_vm.wrapperClass,attrs:{"trigger":"click","options":{}}},[_c('div',{class:_vm.popperClass},[_vm._t("default")],2),_vm._v(" "),_c('a',{class:_vm.buttonClass,attrs:{"slot":"reference","href":"#"},domProps:{"innerHTML":_vm._s(_vm.button)},on:{"click":function($event){$event.preventDefault();}},slot:"reference"})])
}
var staticRenderFns = []

export { render, staticRenderFns }